import { Select } from 'antd'
import data from '../data/gdp-per-capita-by-country-2023.json'

export const AgeBasedDiscountQuestion = ({
  value,
  onChange = () => {},
  onBlur = () => {},
}) => {
  return (
    <Select
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      style={{ width: '100%' }}
    >
      <Select.Option value={'18-21'}>18-21</Select.Option>
      <Select.Option value={'22-25'}>22-25</Select.Option>
      <Select.Option value="26+">26 and above</Select.Option>
    </Select>
  )
}

export const GeographyBasedDiscountQuestion = ({
  value,
  onChange = () => {},
  onBlur = () => {},
}) => {
  const countries = data?.map((c) => c.country).sort()
  return (
    <Select
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      allowClear
      showSearch={true}
      style={{ width: '100%' }}
    >
      {countries?.map((d) => (
        <Select.Option key={d} value={d}>
          {d}
        </Select.Option>
      ))}
    </Select>
  )
}
